import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface DmaModeWarningModalProps {
	visible: boolean;
	onClose: () => void;
}

function DmaModeWarningModal({ visible, onClose }: DmaModeWarningModalProps) {
	return (
		<Modal
			open={visible}
			onCancel={onClose}
			onOk={onClose}
			title={
				<div className="flex items-center gap-2">
					<ExclamationCircleOutlined className="text-orange-500 text-xl" />
					<span>DMA Lens Warning</span>
				</div>
			}
			okText="OK"
			cancelButtonProps={{ style: { display: 'none' } }}
			centered
			width={500}
		>
			<div className="py-4">
				<p className="text-base text-gray-700 m-0">
					Please select a <strong>minimum range of 7 days</strong> to perform water balance
					calculations.
				</p>
			</div>
		</Modal>
	);
}

export default DmaModeWarningModal;
